module.exports = __webpack_public_path__ + "img/5-andre-leveque.5eee92fa.png";